import { FormControl } from "@angular/forms";

export function ValidateHouseSuffix(c: FormControl) {
  let ONLY_ALPHABETIC_CHARACTERS = /^[a-zA-Z]+$/i;
  let ONLY_NUMERIC_CHARACTERS = /^[0-9]+$/i;
  let THREE_ALPHABETIC_CHARACTERS = /^[a-zA-Z]{0,3}$/i;
  let THREE_NUMERIC_CHARACTERS = /^[0-9]{0,3}$/i;
  let ONE_ALPHABETIC_AND_THREE_NUMERIC_CHARACTERS = /^([a-zA-Z])([0-9]{1,3})$/i;

  if (!c.value) return null;

  var validateResultOnlyAlphabeticCharacters = ONLY_ALPHABETIC_CHARACTERS.test(
    c.value
  );
  var validateResultOnlyNumericCharacters = ONLY_NUMERIC_CHARACTERS.test(
    c.value
  );
  var validateResultThreeAlphabeticCharacters =
    THREE_ALPHABETIC_CHARACTERS.test(c.value);
  var validateResultThreeNumericCharacters = THREE_NUMERIC_CHARACTERS.test(
    c.value
  );
  var validateResultOneAlphabeticAndThreeNumericCharacters =
    ONE_ALPHABETIC_AND_THREE_NUMERIC_CHARACTERS.test(c.value);

  if (
    validateResultThreeAlphabeticCharacters ||
    validateResultThreeNumericCharacters ||
    validateResultOneAlphabeticAndThreeNumericCharacters
  )
    return null;

  if (
    validateResultOnlyAlphabeticCharacters &&
    !validateResultThreeAlphabeticCharacters
  )
    return {
      validateThreeAlphabeticCharacters: {
        valid: false,
      },
    };

  if (
    validateResultOnlyNumericCharacters &&
    !validateResultThreeNumericCharacters
  )
    return {
      validateThreeNumericCharacters: {
        valid: false,
      },
    };

  if (!validateResultOneAlphabeticAndThreeNumericCharacters)
    return {
      validateOneAlphabeticAndThreeNumericCharacters: {
        valid: false,
      },
    };

  return null;
}
